export const OTAP_AVAILABLE = 'Available for OTAP'
export const NO_OBSERVE = 'No observed state'
export const INITIATED = 'Initiated'
export const UP_TO_DATE = 'Up to date - OTAP supported'
export const UNKNOWN_STATE =
  'Unknown. Individual manifest contains no firmware components\r\nParameter name: individualManifest'

export const DEVICE_OTAP_STATE_ID = {
  NoObservedStateId: 0,
  UpToDateOtapSupportedId: 1,
  DeviceIdConflictId: 2,
  OtapOfFirmwareNotSupportedId: 3,
  RequiredFlksNotAvailableId: 4,
  GenerationErrorId: 6,
  AvailableForOtapId: 7,
  InitiatedId: 8,
  OtapErrorId: 9,
  FirmwareDoesNotSupportOtapId: 10,
  DeviceDoesNotHaveAnOtapFeatureLicenseId: 11,
  PartialObservedStateId: 12,
  BlockedFirmwareComponentId: 13,
  BootCodeBugNoSolutionId: 14,
  BootCodeBugMustApproveWithCorrectFirmwareId: 15
}

export const DEVICE_OTAP_STATE_RESOURCES = {
  0: 'Value_NoObservedState',
  1: 'Value_UpToDateAndOtapSupported',
  2: 'Value_DeviceIdConflict',
  3: 'Value_OtapOfFirmwareNotSupported',
  4: 'Value_RequiredFLKsNotAvailable',
  6: 'Value_GenerationError',
  7: 'Value_AvailableForOtap',
  8: 'Value_Initiated',
  9: 'Value_OtapError',
  10: 'Value_FirmwareDoesNotSupportOtap',
  11: 'Value_DeviceDoesNotHaveAnOtapFeatureLicense',
  12: 'Value_PartialObservedState',
  13: 'Value_BlockedFirmwareComponent',
  14: 'Value_BootCodeBugNoSolution',
  15: 'Value_BootCodeBugMustApproveWithCorrectFirmware'
}

export const OUT_OF_DATE = 'Out of date'
export const LASTEST_VERSION = 'Latest version'
export const MANDATORY_VERSION = 'Mandatory version'

export const MANIFEST_GENERATION_ERROR_TYPE = {
  UnknownError: 0,
  BandMismatchError: 1,
  WritingDeviceValuesFailedError: 2,
  MissingFirmwareComponentError: 3,
  InsufficientDiskSpaceError: 4,
  AudioFilesNotSupportedError: 5,
  FailedToRetrieveProgrammingApplication: 6,
  FailedToRetrieveCalibrationApplication: 7,
  InvalidProgrammingApplication: 8,
  InvalidCalibrationApplication: 9,
  BandRangeMismatchError: 10,
  MoreThanOneProgrammingFile: 11,
  InvalidConfigurationForDevice: 12,
  MissingTorsoState: 13,
  FirmwareIsNotCompatibleError: 14,
  UnknownDeviceMetaVersion: 15,
  MissingDiscoveryBlob: 16,
  PatchGenerationFailed: 17
}

export const MANIFEST_GENERATION_ERROR_RESOURCES = {
  0: 'Value_UnknownError',
  1: 'Value_BandMismatchError',
  2: 'Value_WritingDeviceValuesFailedError',
  3: 'Value_MissingFirmwareComponentError',
  4: 'Value_InsufficientDiskSpace',
  5: 'Value_AudioFilesNotSupportedError',
  6: 'Value_FailedToRetrieveProgrammingApplication',
  7: 'Value_FailedToRetrieveCalibrationApplication',
  8: 'Value_InvalidProgrammingApplication',
  9: 'Value_InvalidCalibrationApplication',
  10: 'Value_BandRangeMismatchError',
  11: 'Value_MoreThanOneProgrammingFile',
  12: 'Value_InvalidConfigurationForDevice',
  13: 'Value_TorsoMissingFirmware',
  14: 'Value_FirmwareIsNotCompatible',
  15: 'Value_UnknownDeviceMetaVersion',
  16: 'Value_MissingDiscoveryBlob',
  17: 'Value_PatchGenerationFailed'
}

export const INDIVIDUAL_MANIFEST_GENERATION_STATE = {
  GeneratingId: 0,
  ErrorId: 1,
  CompleteId: 2,
  WaitingForGroupGenerationId: 3,
  QueuedForGenerationId: 4
}

export const INDIVIDUAL_MANIFEST_GENERATION_STATE_RESOURCES = {
  0: 'Value_Generating',
  1: 'Value_GeneratingError',
  2: 'Value_Complete',
  3: 'Value_WaitingForGroupGeneration',
  4: 'Value_QueuedForGeneration'
}

export const DEVICE_STATE = {
  LASTEST_VERSION: 1,
  MANDATORY_VERSION: 2,
  OUT_OF_DATE: 3
}

export const OTAP_QUEUE_STATE = {
  NotRegisteredId: 0,
  QueuedId: 1,
  TransferringId: 2,
  TimedOutId: 3,
  PendingActivationId: 4,
  NoSiteId: 5
}

export const OTAP_QUEUE_STATE_RESOURCES = {
  0: 'Value_NotRegistered',
  1: 'Value_Queued',
  2: 'Value_Transferring',
  3: 'Value_TimedOut',
  4: 'Value_PendingActivation',
  5: 'Value_NoSite'
}
